/** @jsxImportSource @emotion/react */

import { message } from "antd";
import Container from "components/common/Container";
import _map from "lodash/map";
import { Link } from "react-router-dom";

import { MemberMenuStyle } from "./index.style";
import { MEMBER_MENU_MOBILE } from "./menu-list";

const menuItems = _map(MEMBER_MENU_MOBILE, (item) => {
  return {
    ...item,
    icon: <item.icon css={MemberMenuStyle.menuIcon} />,
  };
});

const MemberMenu = () => {
  const handleClick = (link: string) => {
    if (link === "#") {
      message.error("Tính năng này hiện tại đang bảo trì!!");
      return;
    }
  };

  return (
    <Container>
      <ul css={MemberMenuStyle.self}>
        {_map(menuItems, (item, index) => (
          <li css={MemberMenuStyle.menuItem} key={index}>
            {
              <Link
                to={item.to as string}
                onClick={() => handleClick(item.to as string)}
              >
                {item.icon}
                <span css={MemberMenuStyle.menuTitle}>{item.label}</span>
              </Link>
            }
          </li>
        ))}
      </ul>
    </Container>
  );
};

export default MemberMenu;
